import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { SectionHeading, EmptySection, Field } from './shared';
import PhotoGrid from './PhotoGrid';
import type { PhotoAttachmentWithUrl } from '@/services/db/dsrDetail';

interface Props {
  data: any[];
  photos?: PhotoAttachmentWithUrl[];
}

const ADEQUACY_COLORS: Record<string, string> = {
  adequate: 'bg-mozaic-green/15 text-mozaic-green',
  adequate_with_comments: 'bg-mozaic-teal/15 text-mozaic-teal',
  inadequate: 'bg-mozaic-orange/15 text-mozaic-orange',
};

const ADHERENCE_COLORS: Record<string, string> = {
  following_jsa: 'bg-mozaic-green/15 text-mozaic-green',
  minor_deviations: 'bg-mozaic-orange/15 text-mozaic-orange',
  not_following_jsa: 'bg-mozaic-red/15 text-mozaic-red',
};

export default function JSAEvaluationsSection({ data, photos = [] }: Props) {
  return (
    <section>
      <SectionHeading id="section-jsa-evaluations" title="JSA Evaluations" count={data.length} />
      {data.length === 0 ? (
        <EmptySection name="JSA evaluations" />
      ) : (
        <div className="mt-2 space-y-3">
          {data.map((row: any) => (
            <Card key={row.id}>
              <CardContent className="pt-4">
                <div className="mb-2 flex items-center gap-2">
                  <span className="text-sm font-medium">{row.jsa_reference}</span>
                  <Badge
                    className={ADEQUACY_COLORS[row.adequacy_rating] ?? 'bg-muted text-muted-foreground'}
                  >
                    {(row.adequacy_rating ?? '').replace(/_/g, ' ')}
                  </Badge>
                  <Badge
                    className={ADHERENCE_COLORS[row.process_adherence] ?? 'bg-muted text-muted-foreground'}
                  >
                    {(row.process_adherence ?? '').replace(/_/g, ' ')}
                  </Badge>
                </div>
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
                  <Field label="Activity" value={row.activity_description} />
                  <Field label="Work Crew" value={row.work_crew} />
                  <Field label="Hazards Identified" value={row.hazards_identified_count} />
                  <Field label="Controls in Place" value={row.controls_in_place} />
                  <Field label="Observer" value={row.observer_name} />
                  {row.corrective_action && (
                    <div className="col-span-full">
                      <Field label="Corrective Action" value={row.corrective_action} />
                    </div>
                  )}
                  {row.comments && (
                    <div className="col-span-full">
                      <Field label="Comments" value={row.comments} />
                    </div>
                  )}
                </div>
                <PhotoGrid photos={photos} entityId={row.id} />
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
